/**
 *
 *
 *
 *
 */
export function notNullQuerySelector<T extends Element = HTMLElement>(selectors: string, parent: ParentNode = document): T {
    const element = parent.querySelector<T>(selectors);

    if (!element) {
        throw new Error(`can not select '${selectors}'`);
    }

    return element;
}
